const domReady = () => new Promise(resolve => {
  if(document.readyState === 'complete') {
    resolve()
  } else {
    window.addEventListener('load', () => {resolve()});
  }
})

export default domReady
